import { IWorkItemManager } from "../types";

export class CachingService {
    constructor(private workItemManager: IWorkItemManager) {
    }

    private static async getCacheKey(key: string, workItemManager: IWorkItemManager) {
        const workItemId = await workItemManager.getId();
        return `wi${workItemId}-${key}`;
    }

    static async getValue(key: string, workItemManager: IWorkItemManager) {
        const fullKey = await CachingService.getCacheKey(key, workItemManager);
        return window.sessionStorage.getItem(fullKey);
    }

    static async setValue(key: string, value: string,  workItemManager: IWorkItemManager) {
        const fullKey = await CachingService.getCacheKey(key, workItemManager);
        window.sessionStorage.setItem(fullKey, value);
    }

    static async clear(key: string, workItemManager: IWorkItemManager) {
        const fullKey = await CachingService.getCacheKey(key, workItemManager);
        window.sessionStorage.removeItem(fullKey);
    }

    async getValue(key: string) {
        return CachingService.getValue(key, this.workItemManager);
    }

    async setValue(key: string, value: string) {
        return CachingService.setValue(key, value, this.workItemManager);
    }

    async clear(key: string) {
        return CachingService.clear(key, this.workItemManager);
    }
}